// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Skillet$LiteracyplanetTupperware from "./Skillet.res.mjs";
import * as PilotStemHeading$LiteracyplanetTupperware from "../v3/PilotStemHeading.res.mjs";
import * as TupperwareLayoutSwitch$LiteracyplanetTupperware from "../v3/TupperwareLayoutSwitch.res.mjs";

function SkilfulStemHeading(props) {
  var children = props.children;
  if (Curry._1(TupperwareLayoutSwitch$LiteracyplanetTupperware.use, undefined) === "Pilot") {
    return React.createElement(PilotStemHeading$LiteracyplanetTupperware.make, {
                children: children
              });
  } else {
    return React.createElement("div", {
                className: Skillet$LiteracyplanetTupperware.SkilfulStemHeading.className
              }, children);
  }
}

var make = SkilfulStemHeading;

var $$default = SkilfulStemHeading;

export {
  make ,
  $$default as default,
}
/* react Not a pure module */
